import downloadBoxMixin from './download-box-mixin.js';

/** @type {import('@vue/compat').ComponentOptions} */
export default {
  mixins: [downloadBoxMixin],
  data: {
    list: '',
    data: '',
    show: false,
    index: 0,
    scroll: '',
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      if (this.$refs.scrollTab) {
        this.scroll = new BScroll(this.$refs.scrollTab, {
          scrollX: true,
          probeType: 3,
          click: true,
        });
      }
    });
  },
  methods: {
    getList() {
      const data = {
        post_id: qk_global.post_id,
      };

      if (this.data) return;

      // Sidebar widget loads data and syncs back to the main download box.
      if (document.querySelector('#qk-download-box')) return;

      this.$http.post(`${qk_rest_url}getDownloadData`, data).then((res) => {
        this.list = res.data;
        this.data = this.list[0];
      }).catch((err) => {
        qkShowApiError(err, '加载下载信息失败');
      });
    },
  },
};
